// extracted by css-extract-rspack-plugin
export default {"dropzone":"ioah0","dropzoneActive":"LkTlc","dropzoneError":"zkHv0"};